import { css } from '@emotion/react'
import React from 'react'

const pathColor = css({ fill: 'currentcolor' })

const AddFriend = (props) => (
    <svg
        width={29}
        height={24}
        viewBox="0 0 29 19"
        data-testid="IconButton__AddFriend"
        {...props}
    >
        <title>{'Add Friend'}</title>
        <g>
            <path
                d="M3 4v3H0v2h3v3h2V9h3V7H5V4zM19.1 15.55l-.1.1-.11-.1C14.14 11.24 11 8.39 11 5.5c0-2 1.5-3.5 3.5-3.5 1.54 0 3.04 1 3.57 2.36h1.86C20.46 3 21.96 2 23.5 2c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05zM23.5 0c-1.74 0-3.41.81-4.5 2.08C17.91.81 16.24 0 14.5 0 11.42 0 9 2.41 9 5.5c0 3.77 3.4 6.86 8.55 11.53L19 18.35l1.45-1.32C25.6 12.36 29 9.27 29 5.5 29 2.41 26.58 0 23.5 0z"
                css={pathColor}
            />
        </g>
    </svg>
)

export default React.memo(AddFriend)
